import { useEffect, useRef, useState } from 'react';

type UseReadyBufferOpts = {
  bufferTime?: number;
  id?: string;
  hold?: boolean;
  initial?: boolean;
};

export function useReadyBuffer(opts: UseReadyBufferOpts = {}) {
  const { bufferTime = 250, hold, id, initial = false } = opts;
  const [ready, setReady] = useState(!hold && initial);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (hold) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setReady(true), bufferTime);

    const timeout = timeoutRef.current;
    // eslint-disable-next-line consistent-return
    return () => {
      if (timeout) clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setReady(false);
    if (hold) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setReady(true), bufferTime);

    const timeout = timeoutRef.current;
    // eslint-disable-next-line consistent-return
    return () => {
      if (timeout) clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, hold]);

  return ready;
}
